import { decode } from "../utils/Utils";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";


// creates link to Hostage Page to be used in any relevant component (Card, Story etc)
export const HostagePageLink = ({ hostageId,hostageName }: { hostageId: string,hostageName: string }) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  if (!hostageId || !hostageName) {
    return null;
  }
  return (
    <span
      onClick={() => navigate(`/hostage/${hostageId}`)}
      style={{ display: "block", cursor: "pointer", color: '#FF395D' }}
    >
      {decode(t("eventCard.hostagePageLink", { hostageName: hostageName }))}
    </span>
  )
}